import classNames from 'classnames';

import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsCharacteristics.sss';

interface Props {
  className?: string,
}

export const ProductDetailsCharacteristicsSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <ul className={s.list}>
        {Array(6).fill(null).map((_, i) => (
          <li
            key={i}
            className={s.item}
          >
            <Skeleton
              width='100%'
              height='14px'
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
